import { noop } from '@vkontakte/vkjs';
import { SnackbarProps } from '@vkontakte/vkui';
import React, { createContext } from 'react';

interface ShowSnackbarParams extends Omit<SnackbarProps, 'onClose'> {
  text: string;
  'data-testid'?: string;
}

interface OtherProps extends Omit<SnackbarProps, 'subtitle' | 'children' | 'onClose'> {
  'data-testid'?: string;
}

export type ShowCustomSnackbar = (text: string, subtitle?: string, otherProps?: OtherProps) => void;

export type SetSnackbarOffset = (panelOffset: number, panelKey: string, force: boolean) => void;

export interface SnackbarContextParams {
  showSnackbar: (snackbar: React.ReactElement<SnackbarProps> | ShowSnackbarParams) => void;
  showSuccessSnackbar: ShowCustomSnackbar;
  showErrorSnackbar: ShowCustomSnackbar;
  showInfoSnackbar: ShowCustomSnackbar;
  clearSnackbar: VoidFunction;
  setOffset: SetSnackbarOffset;
}

export const SnackbarContext = createContext<SnackbarContextParams>({
  showSnackbar: noop,
  showSuccessSnackbar: noop,
  showErrorSnackbar: noop,
  showInfoSnackbar: noop,
  clearSnackbar: noop,
  setOffset: noop,
});

export type ShowSnackbar = SnackbarContextParams['showSnackbar'];
export type ShowErrorSnackbar = SnackbarContextParams['showErrorSnackbar'];
export type ShowSuccessSnackbar = SnackbarContextParams['showSuccessSnackbar'];
export type ShowInfoSnackbar = SnackbarContextParams['showInfoSnackbar'];
